import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown';
import { UserIcon } from '@/components/ui/user-icon';
import { Button } from '../ui/button';
import { useGlobalStore } from '@/stores/store';
import { cn } from '@/lib/utils';
import { useShallow } from 'zustand/react/shallow';
import { useLogout } from '@/hooks/use-logout';

export const UserProfileDesktop = () => {
  const { isAuthenticated, loginCredentials, email } = useGlobalStore(
    useShallow((store) => ({
      email: store.authStore.authFlow.email,
      loginCredentials: store.authStore.loginCredentials,
      isAuthenticated: store.authStore.isAuthenticated,
    }))
  );

  const handleLogout = useLogout();

  if (!isAuthenticated || !loginCredentials) {
    return null;
  }

  const { firstName, lastName } = loginCredentials.individual;
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger className={cn('p-0', {})}>
        <div className="flex items-center gap-[3px]">
          <UserIcon initial={firstName[0]} className="shrink-0" size="small" />
          <span className="text-black font-nunito700 text-xs">
            {firstName} {lastName[0]}.
          </span>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={cn(
          'p-4 rounded-[12px] bg-warp-green-50 border-warp-green-50',
          {}
        )}
      >
        <DropdownMenuLabel className="px-0">
          <div className="flex gap-2">
            <UserIcon initial={firstName[0]} />
            <div className="flex flex-col">
              <span className="font-nunito700 text-black text-[14px]">
                {firstName} {lastName}
              </span>
              <span className="font-nunito300 text-grey-500 text-xs">
                {email}
              </span>
            </div>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-grey-50 my-4" />
        <DropdownMenuItem className="px-0">
          <Button
            onClick={handleLogout}
            variant="secondary"
            className="w-full bg-warp-green-50"
            size="extraSmall"
          >
            Logout
          </Button>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
